import { useMutation } from '@apollo/client';
import { deleteCoverageHours } from 'graphql-queries';

export class CoverageHoursDeleteError extends Error {
  constructor(message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'CoverageHoursDeleteError';
  }
}

export type UseDeleteCoverageHoursArgs = {
  channelId: string;
};

export type UseDeleteCoverageHoursResult = {
  deleteCoverageHours: (routingId: string) => Promise<void>;
  loading: boolean;
};

export function useDeleteCoverageHours({
  channelId,
}: UseDeleteCoverageHoursArgs): UseDeleteCoverageHoursResult {
  const [executeDelete, { loading }] = useMutation(deleteCoverageHours);

  const deleteRouting = async (routingId: string) => {
    try {
      await executeDelete({ variables: { input: { channelId, routingId } } });
    } catch (cause) {
      throw new CoverageHoursDeleteError('Could not delete coverage hours', {
        cause,
      });
    }
  };

  return { deleteCoverageHours: deleteRouting, loading };
}
